module.exports = (fox) => {
	require('./html5player')(fox);
	
	fox.registerWidget('Content_Html5Player', {
		configure: function (options) {
			this.available4K = !(/iPhone|iPad/.test(navigator.platform) || /Windows NT 6.1/.test(navigator.userAgent) && /rv:11.0/.test(navigator.userAgent));
			this.MOBILE_DEVICES_START_FORMAT = 'ipod';
			this.DESKTOP_START_FORMAT = 'hd1080'; /* !!! do not set this.DESKTOP_START_FORMAT > hd1080 */

			this.registerOptions('', {
				getMapMethod: 'site.format.getMap',
				jsonizeMapRequest: true,
				resourceIdParamName: 'contentId',
				'handleWom.recieveContentId': {
					widget: '@this',
					event: 'setContentId',
					callback: 'recieveContentId'
				}
			});

			this.mode = 'format';
			this.callParent('configure', arguments);
		},

		recieveContentId: function (id) {
			this.setPoster('');
			this.formatGetMap(id);
		},

		getMapApi: function () {
			var api = this.wom1('#mapApi');

			if (!api) {
				api = this.embedWidget('mapApi', 'Api', {
					method: this.getOption('getMapMethod')
				});

				api.run();
			}

			return api;
		},

		formatGetMap: function(id, resCallback, callbackParams) {
			var
				api = this.getMapApi(),
				resIdParamName = this.getOption('resourceIdParamName'),
				apiParams = {mode: this.mode == 'preview' ? 'preview' : 'format'};

			this.setContentId(id);
			this.waitEvent(api, 'success', resCallback || 'formatGetMapApiSuccessHandler', callbackParams || {});

			apiParams[resIdParamName] = this.getContentId();
			api.send(apiParams, this.getOption('jsonizeMapRequest'));
		},

		formatGetMapApiSuccessHandler: function(data) {
			this.preparePlayerData(data.answer.response);
		},

		preparePlayerData: function (map) {
			this.setFormatMap(map).changeFormat(this.getStartFormat());
			if (fox.utils.isTouchDevice() && !this.getPoster()) {
				this.setPoster(this.getPrimaryThumb());
			}
		},

		getStartFormat: function () {
			if(fox.getEnv('siteProps.settingId')){
				fox.each(this.getFormatMap().download, function(val) {
					val.link = val.link + (val.link.indexOf('?') == -1 ? '?' : '%26') + 'settingId=' + fox.getEnv('siteProps.settingId');
				}, this);
			}

			var format, height = 0;

			if (fox.utils.isTouchDevice() && this.getFormatMap().view[this.MOBILE_DEVICES_START_FORMAT]) {
				return this.setVideoFormat(this.MOBILE_DEVICES_START_FORMAT);
			} else if (this.getFormatMap().view[this.DESKTOP_START_FORMAT]) {
				return this.setVideoFormat(this.DESKTOP_START_FORMAT);
			}

			fox.each(this.getFormatMap().view, function(val, name) {
				var fh = Number(val.height);
				if (!format || (height < fh)) {
					height = fh;
					format = name;
				}
			}, this);


			return this.setVideoFormat(format);
		},

		buildBitrates: function() {
			var bitrates = [];

			fox.each(this.getFormatMap().view, function(val, name) {

				if (!this.available4K && name === 'hd2160') {
					return;
				}
				if (val.roles && !fox.inArray(val.roles, this.mode)) {
					return; // means 'continue'
				}
				var domain = fox.site.getOption('siteDomain') || (window.location.protocol + '//' + window.location.host);
				var clip = domain + val.link, params = ['video=1', 'rand=' + Date.parse(new Date())];

				if (this.getOption('useHash') && clip.indexOf('publisher_auth=') === -1) {
					params.push('publisher_auth=' + fox.getEnv('siteProps.publisher_auth'));
				}

				if (fox.utils.safari()) 
					params.push(`auth_hash=${this.isAuthorized() ? (fox.cookie.get('user_auth') || '') : 'empty'}`)

				if(fox.getEnv('siteProps.settingId'))
					params.push('settingId=' + fox.getEnv('siteProps.settingId'));

				clip += (clip.indexOf('?') === -1 ? '?' : '&') + params.join('&');
				
				var bitrate = {
					icon: parseInt(val.hd) ? name === 'hd2160' ? '4k_19' : 'hd' : 'sd',
					name: val.height + 'p.',
					height: val.height,
					sources: [{
						type: 'video/mp4',
						src: clip
					}],
					isDefault: name === this.getVideoFormat()
				};
				
				bitrates.push(bitrate);
			}, this);

			if (bitrates.length) {
				bitrates.sort(function (a, b) {
					var aH = parseInt(a.height);
					var bH = parseInt(b.height);
					if (aH > bH) {
						return -1;
					}

					if (aH < bH) {
						return 1;
					}

					return 0;
				});
			}
			this.setBitrates(bitrates);
			return this;
		},

		addParamToLink: function() {  },

		//only mc-admin feature
		switchMode: function(mode) {
			this.mode = mode == 'preview' ? 'preview' : 'format';
			this.buildBitrates();
			var map = this.getFormatMap().view;
			var bitrates = this.getBitrates();

			switch (this.mode) {
				case 'preview':
					fox.each(map, function(format) {
						format.link = format.link + '/preview';
					});

					fox.each(bitrates, function(item) {
						item.onSelectArguments.clip.url = item.onSelectArguments.clip.url + '/preview';
					});
				break;

				default:
					fox.each(map, function(format) {
						format.link = format.link.replace('\/preview', '');
					});

					fox.each(bitrates, function(item) {
						item.onSelectArguments.clip.url = item.onSelectArguments.clip.url.replace('\/preview', '');
					});
				break;
			}

			return this;
		},

		getPrimaryThumb: function(size) {
			var hSize = size,
				formats = this.getFormatMap(),
				alias;

			if (!hSize) {
				if (fox.utils.isTouchDevice()) {
					var format = formats.view[this.MOBILE_DEVICES_START_FORMAT];
					if (format) {
						hSize = format.height;
					} else {
						hSize = 480;
					}
				} else {
					var format = formats.view[this.DESKTOP_START_FORMAT];
					if (format) {
						hSize = format.height;
					} else {
						hSize = 1080;
					}
				}
			}
			if (hSize > 1080) {
				alias = 'h1360i';
			} else if (hSize > 720) {
				alias = 'h720i'; /* because h1080i doesn't exist */
			} else if (hSize > 480) {
				alias = 'h720i';
			} else {
				alias = 'h480i';
			}
			return (fox.getEnv('smallUrl') || 'http://cdn-small.nl.storage.adultcentro.com/') + this.getContentId() + '/thumb/primary/'+ alias;
		},

		isAuthorized() {
			const pm = this.wom1('@root #permissionManager');

			if (pm)
				return pm.hasAccess('member') || pm.hasAccess('free');

			return !fox.isEmpty(this._wom.getRoot().member);
		}
	}, 'Html5Player');
};



// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/htmlplayer/widget/html5player2.es.js